












































import { Vue, Component, Prop } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button } from 'vant';
import SearchInput from './SearchInput.vue';
import VoteButton from './VoteButton.vue';
import ListVoteButton from './ListVoteButton.vue';
import { getlist } from '../api';
import * as config from '../config';
import { namespace, State } from 'vuex-class';
import * as mutationTypes from '../store/mutation-types';

const Modules = namespace('JKMX20200807');
Vue.use(List).use(Checkbox).use(CheckboxGroup).use(Button);
@Component({
  components: {
    SearchInput,
    VoteButton,
    ListVoteButton,
  },
})
export default class VoteList extends Vue {
  @Prop() listType!: any;
  options = config.OPTHINES;
  loadingStatus = false;
  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];
  result = [];
  SearchData = '';
  ifType = true;
  button = true;
  Time = false;
  TimeMsg = '';
  placeholder = '请输入编号、医院或科室名';

  @Modules.Mutation(mutationTypes.GET_VOTE) getVote!: (PostLike: any) => void;
  @Modules.Mutation(mutationTypes.UPDATE_VOTE) updateVote!: () => void;
  @Modules.State('votes') votes!: {};
  created() {
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    if (Number(this.$route.query.type) === 1) {
      this.ifType = false;
      this.placeholder = '请输入编号、医院或科室名';
    } else {
      this.ifType = true;
      this.placeholder = '请输入编号、医院或医师名';
    }
  }
  // 初使加载
  onLoad() {
    console.log('onLoad加载开始了。搜索内容为：', this.SearchData);
    if (this.loadingStatus === false) {
      this.loadingStatus = true;
      if (this.SearchData) {
        this.startSearch(2);
      } else {
        setTimeout(() => {
          getlist(
            this.options.voteName,
            this.page,
            this.listType,
            this.SearchData,
          ).then((res: any) => this.fetchListData(res));
        }, 150);
      }
    }
  }
  fetchListData(res: any) {
    if (res.code === 100) {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
    this.loadingStatus = false;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    this.$router.push({
      path: 'Detail',
      query: { id: item.id, type: this.listType },
    });
  }
  fetchSearch(e: any) {
    this.SearchData = e;
  }
  // 开始搜索
  startSearch(e: any) {
    console.log('进入搜索', e);
    this.loadingStatus = true;
    if (e === 1) {
      this.page = 1;
      this.getListData = [];
      this.loading = false;
      this.finished = false;
    }
    getlist(
      this.options.voteName,
      this.page,
      this.listType,
      this.SearchData,
    ).then((res: any) => this.fetchListData(res));
  }
  searchNewsData(res: any) {
    this.getListData = [...res.data];
    this.finished = true;
  }
  votSuccess(num: string) {
    // this.detailData.votes = num;
    this.updateVote();
    this.button = false;
    setTimeout(() => {
      this.button = true;
    }, 1000);
  }
}
